
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
@Component({
  components: { Icon }
})
export default class TextWithChevron extends Vue {
  @Prop()
  open!: boolean;
}
